export const getCurrency = () => {
    return window.APP.locale==='pl'?'PLN':'EUR';
};

export const getLanguage = () => {
    const cfg = {pl: 'POLISH', en: 'ENGLISH', de: 'GERMAN'};
    return cfg[window.APP.locale];
};
